import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Snackbar } from "@mui/material";
import { CLOSE_NOTIFICATION } from "../../constants";
import { getNotificationsState } from "../../store/selectors";

/** Avisos flotantes de la app (acción SHOW_NOTIFICATION). */
const NotificationsHandler = () => {
	const dispatch = useDispatch();
	const { show, status, message } = useSelector(getNotificationsState);

	const close = (event, reason) => {
		if (reason !== "clickaway") dispatch({ type: CLOSE_NOTIFICATION });
	};

	return (
		<Snackbar open={Boolean(show && message)} autoHideDuration={4000} onClose={close} anchorOrigin={{ vertical: "top", horizontal: "right" }} sx={{ top: "calc(var(--app-safe-area-top) + 12px) !important" }}>
			<Alert severity={status || "info"} variant="filled" onClose={close} sx={{ width: "100%", overflowWrap: "anywhere" }}>
				{message}
			</Alert>
		</Snackbar>
	);
};

export default NotificationsHandler;
